import { useRef, useEffect } from 'react';

const useOrientationChange = () => {
  const orientationRef = useRef(window.orientation);

  useEffect(() => {
    const handleOrientationChange = () => {
      const currentOrientation = window.orientation;
      if (orientationRef.current !== currentOrientation) {
        orientationRef.current = currentOrientation;
        window.location.reload();
      }
    };

    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);
};

export default useOrientationChange;


// WEBPACK FOOTER //
// ./src/new/Utils/useOrientationChange.jsx